module.exports = __webpack_public_path__ + "images/first-timer-62a15c95b12670eef2aa74116acf6794.png";